import { render, staticRenderFns } from "./EstimateItem.vue?vue&type=template&id=0543224f&scoped=true&"
import script from "./EstimateItem.vue?vue&type=script&lang=ts&"
export * from "./EstimateItem.vue?vue&type=script&lang=ts&"
import style0 from "./EstimateItem.vue?vue&type=style&index=0&id=0543224f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543224f",
  null
  
)

export default component.exports